import React, { ChangeEvent } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { EventReason } from './ComboBoxComponent.types';
import { makeStyles, TextField } from '@material-ui/core';
import { CourierObj } from '../../fetch/fetchInbound';

const useRowStyles = makeStyles(theme => ({
  inputRoot: {
    color: theme.palette.primary.main,
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
  },
}));

export function ComboBoxCourierObj({
  className,
  placeHolderText,
  defaultValue,
  disabled = false,
  id,
  comboBoxItems,
  multiple = false,
  onChange,
  placeholder,
  value,
}: {
  className?: string;
  placeHolderText?: string;
  defaultValue?: CourierObj;
  disabled?: boolean;
  id: string;
  comboBoxItems: CourierObj[];
  multiple?: boolean;
  placeholder?: string;
  onChange: (
    // eslint-disable-next-line @typescript-eslint/ban-types
    event: ChangeEvent<{}>,
    value: string | CourierObj | Array<string | CourierObj>,
    reason: EventReason
  ) => void;
  value?: CourierObj[];
}): JSX.Element {
  const classes = useRowStyles();

  return (
    <Autocomplete
      classes={classes}
      className={className}
      defaultValue={defaultValue}
      filterSelectedOptions
      getOptionLabel={(option: CourierObj) =>
        `${option.firstName ? option.firstName : 'null'} ${
          option.lastName ? option.lastName : ''
        }`
      }
      id={id}
      disabled={disabled}
      multiple={multiple}
      options={comboBoxItems}
      getOptionSelected={(option: CourierObj, value: CourierObj) =>
        option.id === value.id
      }
      onChange={onChange}
      renderInput={params => (
        <div ref={params.InputProps.ref}>
          <TextField
            {...params}
            variant="outlined"
            label={placeHolderText}
            placeholder={placeholder}
          />
        </div>
      )}
    />
  );
}
